import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './@core/utils';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(private authService: AuthService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if(!(!!this.authService.isLoggedIn()))
    {
      return false;
    }
    
    const allowedRoles = next.data["roles"];
    const matchingRoles = this.authService.roles().filter(x => allowedRoles.includes(x));
    return matchingRoles.length > 0;
  }
}